import React from 'react';

export default function Options({ deviceSettingsOpen, onOptionsClicked, showLabel }) {

    return (<div className={"options-container"}>
        <button type="button" className={`btn${deviceSettingsOpen ? " active" : ""}`}
            onClick={() => onOptionsClicked()}
        > 
            {showLabel
                ? <div className="details-icon-prepend">
                    <div className="icon-col">
                        <span className="icon-gear" />
                    </div>
                    <div className="details-col">
                        Manage Audio/Video
                        </div>
                </div>
                : <span className="icon-gear" />
            }
        </button>
    </div>);
}
